export default __webpack_public_path__ + "static/media/Group510.7c91c353.png";